/**
 * Format a week number for display using calendar metadata when available.
 * @param {number} weekNumber
 * @param {Array} calendar - calendar entries from CurrentWeekContext
 * @returns {string}
 */
export function formatWeekLabel(weekNumber, calendar) {
  const weekEntry = calendar?.find((entry) => entry.week === weekNumber);
  if (weekEntry) {
    if (weekEntry.season_type === 'postseason' && weekEntry.week >= 17) {
      return `BW${weekEntry.week - 16}`;
    }
    return `Week ${weekEntry.week}`;
  }
  if (weekNumber >= 17) {
    return `BW${weekNumber - 16}`;
  }
  return `Week ${weekNumber}`;
}
